module.exports = __webpack_public_path__ + "static/media/House-of-Aama.741a2bc9.jpg";